import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Toaster, toaster } from "src/components/ui/toaster"
import { Provider } from "../src/components/ui/provider"

import NavigationBar from './modules/NavigationBar';


import { Button, ButtonGroup } from "@chakra-ui/react"
import NegotiatedCompaniesBanner from './modules/NegotiatedCompaniesBanner';
import NegotiationsCalculator from './modules/NegotiationsCalculator';
import ContactBanner from './modules/ContactBanner';
import MainComponent from './modules/MainComponent';
import PricingComponent from './modules/PricingComponent';
import TestimonialsComponent from './modules/TestimonialsComponent';
import HowItWorksComponent from './modules/HowItWorksComponent';
import FAQComponent from './modules/FAQComponent';
import ContactUsComponent from './modules/ContactUsComponent';
import Footer from './modules/Footer';


function App() {
  return (
    <Provider>
      <div className="App">
          <Toaster />
          <NavigationBar/>
          <MainComponent/>
          <NegotiatedCompaniesBanner/>
          <HowItWorksComponent/>
          <PricingComponent/>
          <TestimonialsComponent/>
          <ContactBanner/>
          <NegotiationsCalculator/>
          <FAQComponent/>
          <ContactUsComponent/>
          <Footer/>
      </div>
    </Provider>
  );
}

export default App;
